import { CounsellorProfile as Profile } from '@unmind/design-system';
import { rem } from 'polished';
import styled from 'styled-components';

export const Container = styled.section`
  background: ${({ theme }) => theme.colors.modal.background};
  padding: ${rem(32)};

  p {
    line-height: 140%;
  }
`;

export const CTAList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: ${rem(24)};
  margin-bottom: 0;
  display: flex;
  gap: ${rem(16)};
  justify-content: space-between;
`;

export const CounsellorProfile = styled(Profile)`
  margin-bottom: ${rem(24)};
`;
